import { useGraphQLQuery } from '@betterment/js-runtime';
import { ErrorBoundary, useFeatureFlag } from '@betterment/shared-components';

import { EnvelopeItem } from './components/EnvelopeItem';
import { EnvelopesDocument } from './graphql/query.envelopes.generated';

import { ListShimmer } from '../ListShimmer';

const EnvelopeNavLinksView: React.FC = () => {
  const { enabled: isEnvelopesReorderingEnabled } = useFeatureFlag({
    splitName: 'retail.envelopes_reordering_q4_2025_enabled',
    context: 'EnvelopesNavLinks',
  });

  const { data } = useGraphQLQuery(EnvelopesDocument, {
    fetchPolicy: 'cache-first',
  });

  if (!data) return <ListShimmer />;
  if (!data.envelopes || !data.envelopes.length) return null;

  const sortedEnvelopes = [...data.envelopes];

  if (isEnvelopesReorderingEnabled) {
    sortedEnvelopes.sort((a, b) => {
      const isAChecking = a.accounts.some(account => account.__typename === 'CheckingAccount');
      const isBChecking = b.accounts.some(account => account.__typename === 'CheckingAccount');

      // Keep checking accounts first
      if (isAChecking && !isBChecking) return -1;
      if (!isAChecking && isBChecking) return 1;

      // If both have checking or neither have checking, sort by orderPosition
      if (a.orderPosition == null && b.orderPosition == null) return 0;
      if (a.orderPosition == null) return 1;
      if (b.orderPosition == null) return -1;
      return a.orderPosition - b.orderPosition;
    });

    return sortedEnvelopes.map(envelope => <EnvelopeItem key={envelope.id} envelope={envelope} />);
  }

  return data.envelopes.map(envelope => <EnvelopeItem key={envelope.id} envelope={envelope} />);
};

export const EnvelopeNavLinks = () => {
  return (
    <ErrorBoundary fallbackType="inline" feature="sidebar" owner="user_engagement">
      <EnvelopeNavLinksView />
    </ErrorBoundary>
  );
};
